import _taggedTemplateLiteral from "/home/bamboo/bamboo-agent-home/xml-data/build-dir/UDFGE-ESHOP4-JOB1/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject;
import { jsxs, jsx } from 'react/jsx-runtime';
import { useState, useEffect } from 'react';
import styled from 'styled-components';
import DesktopHeader from './DesktopHeader.js';
import MobileHeader from './MobileHeader.js';
import MobileMenu from './MobileMenu.js';
import theme$1 from '../../../../theme/index.js';
import '../../../../../../authentication/context/AuthenticationProvider.js';
import { DEFAULT_HEADER_LOGO_URL, DEFAULT_APP_NAME } from '../../../../../../authentication/helpers/constants.js';
import '@geit/ui-components';
import { useAppConfig } from '../../../../../../authentication/hooks/useAppConfig.js';
import { getMenus } from '../../../../../../authentication/helpers/utils.js';
import '../../../../../../authentication/navigate.js';
const StyledHeader = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  background-color: ", ";\n  // border-top: 4px solid ", ";\n  // box-shadow: 0 2px 5px 0 ", ";\n"])), props => props.theme === "dark" ? theme$1.colours.darkslate : theme$1.colours.white, theme$1.colours.singtelred, theme$1.colours.grey_d6);
const baseUrl = "";
const theme = "dark";
const appName = DEFAULT_APP_NAME;
const showHamburger = true;
let hideSubMenuTimeout = void 0;
const EmpowerHeader = _ref => {
  let {
    logoUrl = DEFAULT_HEADER_LOGO_URL,
    isAnonymous,
    additionalControl,
    onApplySegment,
    onClickLogo,
    onClickLogout,
    onClickMenu
  } = _ref;
  const [isHamburgerMenuOpen, setIsHamburgerMenuOpen] = useState(false);
  const [menuHoverKey, setMenuHoverKey] = useState(-1);
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const {
    appUrl
  } = useAppConfig();
  let logoLink = logoUrl;
  if (appUrl) {
    if (!logoUrl.startsWith("http")) {
      logoLink = "".concat(appUrl).concat(logoUrl);
    }
  }
  const logo = {
    alt: appName,
    link: "/",
    src: logoLink
  };
  const handleDesktopMenuMouseEnter = key => {
    clearTimeout(hideSubMenuTimeout);
    setMenuHoverKey(key);
  };
  const handleDesktopMenuMouseLeave = () => {
    hideSubMenuTimeout = setTimeout(() => {
      setMenuHoverKey(-1);
    }, 150);
  };
  const handleHamburgerClick = () => {
    setIsHamburgerMenuOpen(prev => !prev);
  };
  useEffect(() => {
    const checkPageSize = e => {
      const target = e.target;
      setShowMobileMenu(target.innerWidth < theme$1.grid.breakpoints.lg * 16);
    };
    setShowMobileMenu(window.innerWidth < theme$1.grid.breakpoints.lg * 16);
    window.addEventListener("resize", checkPageSize);
    return () => {
      window.removeEventListener("resize", checkPageSize);
    };
  }, []);
  const config = useAppConfig();
  const [menuItems, setMenuItems] = useState();
  useEffect(() => {
    getMenus(config).then(menus => {
      setMenuItems(menus);
    });
  }, [config]);
  return /* @__PURE__ */jsxs(StyledHeader, {
    theme,
    id: "header",
    children: [/* @__PURE__ */jsx(MobileHeader, {
      baseUrl,
      logoAlt: logo.alt,
      logoLink: logo.link,
      logoSrc: logo.src,
      onHamburgerClick: handleHamburgerClick,
      showHamburger,
      theme
    }), !showMobileMenu && /* @__PURE__ */jsx(DesktopHeader, {
      baseUrl,
      logoAlt: logo.alt,
      logoLink: logo.link,
      logoSrc: logo.src,
      menuHoverKey,
      onMenuMouseEnter: handleDesktopMenuMouseEnter,
      onMenuMouseLeave: handleDesktopMenuMouseLeave,
      theme,
      menuItems,
      isAnonymous,
      additionalControl,
      onApplySegment,
      onClickLogo,
      onClickLogout,
      onClickMenu
    }), showMobileMenu && /* @__PURE__ */jsx(MobileMenu, {
      baseUrl,
      isHamburgerMenuOpen,
      logoAlt: logo.alt,
      logoLink: logo.link,
      logoSrc: logo.src,
      onClose: handleHamburgerClick,
      theme,
      menuItems,
      isAnonymous,
      additionalControl,
      onClickMenu
    })]
  });
};
export { StyledHeader, EmpowerHeader as default };